export const CATEGORY_PALETTE = ["#FF6A00", "#FFD500", "#34D399", "#60A5FA", "#A78BFA", "#F472B6", "#F87171", "#2DD4BF", "#A3E635", "#94A3B8"];

export function categoryColor(org, name) {
  if (!org?.category_colors_enabled || !name) return null;
  return (org.category_colors || {})[name] || null;
}

export function CategoryTag({ org, name, testid, className = "" }) {
  const c = categoryColor(org, name);
  if (!name) return null;
  if (!c) return <span data-testid={testid} className={`text-xs text-zinc-500 ${className}`}>{name}</span>;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium text-zinc-200 ${className}`} style={{ background: `${c}26`, boxShadow: `inset 0 0 0 1px ${c}55` }}>
      <span className="h-2 w-2 rounded-full" style={{ background: c }} />{name}
    </span>
  );
}

export function CategoryDot({ org, name }) {
  const c = categoryColor(org, name);
  return c ? <span title={name} className="inline-block h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: c }} /> : null;
}

export function ColorSwatches({ value, onChange, testid }) {
  return (
    <div className="flex flex-wrap items-center gap-1" data-testid={testid}>
      {CATEGORY_PALETTE.map((c) => (
        <button key={c} type="button" data-testid={`${testid}-${c.slice(1)}`} onClick={() => onChange(value === c ? null : c)} title={value === c ? "Retirer la couleur" : c}
          className={`h-5 w-5 rounded-full transition-transform hover:scale-110 ${value === c ? "ring-2 ring-white ring-offset-2 ring-offset-zinc-950" : ""}`} style={{ background: c }} />
      ))}
    </div>
  );
}
